// Captures OAuth authorization params from the initial URL at MODULE-LOAD time —
// before NavigationContainer mounts and React Navigation's linking resolver can
// strip the query string (an unmapped path like /login resets to a default
// route and drops `?client_id=…`). Reading window.location.search inside a
// screen effect is too late; this runs once when the bundle first evaluates.
//
// When present, the app forces the OAuth consent screen to render regardless of
// auth state (a logged-in user must still be able to approve the connection).

let captured: URLSearchParams | null = null;

try {
  if (typeof window !== "undefined" && window.location?.search) {
    const p = new URLSearchParams(window.location.search);
    if (p.get("client_id") && p.get("redirect_uri")) {
      captured = p;
    }
  }
} catch {
  captured = null;
}

/** The OAuth authorization params from the initial page load, or null. */
export function getCapturedOAuth(): URLSearchParams | null {
  return captured;
}

/** True if the app was opened as an OAuth authorization request. */
export function isOAuthFlow(): boolean {
  return captured !== null;
}
